import { connect } from 'react-redux';
import { logout } from '../../actions/session_actions';
import Logout from './logout';

const mapStateToProps = (state) => {
  return {

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: user => dispatch(logout(user))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Logout);